<template>
  <Modal :destroyOnClose="true" :visible="isOpen" @cancel="handleCancel" :zIndex="999" :footer="null" :width="900">
    <component :is="view"> </component>
  </Modal>
</template>
<script lang="ts" src="./device-setting-modal.ts"></script>
